<script setup lang="ts">
import { ExclamationCircleIcon, CashIcon } from '@heroicons/vue/solid'
import { i18n } from '../../../localization'
import Alert from '../../base/Alert.vue'
import {
    deletePendingInvestmentCookie,
    getPendingInvestmentCookie,
} from '../../../utilities/investment-process/usePendingInvestmentProcess'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import { ref } from 'vue'
import { isNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'

let investmentProcess = ref(getPendingInvestmentCookie())

function navigateToInvestmentProcess() {
    window.location.href = investmentProcess.value.return_url
}

function deletePendingInvestmentProcess() {
    deletePendingInvestmentCookie()
    investmentProcess.value = getPendingInvestmentCookie()
}

// TODO: Only show when all required for investment are present?
</script>

<template>
    <Alert
        v-if="investmentProcess && investmentProcess.account_type === 'natural' && isNaturalProfile()"
        :title-text="i18n.global.t('pending_investment_process.title')"
        :description-text="
            i18n.global.t('pending_investment_process.description', { campaign_name: investmentProcess.asset_title })
        ">
        <template #icon>
            <CashIcon class="h-12 w-12 text-gray-300"></CashIcon>
            <ExclamationCircleIcon
                class="absolute bottom-0 right-[-5px] h-6 w-6 rounded-full bg-white text-yellow-400"></ExclamationCircleIcon>
        </template>
        <template #buttons>
            <div class="md-mt-0 mt-2 flex w-full justify-center gap-2">
                <BaseButtonMuted @click="deletePendingInvestmentProcess()">
                    <span class="font-bold">{{ $t('pending_investment_process.cancel_button') }}</span>
                </BaseButtonMuted>
                <BaseButtonMuted @click="navigateToInvestmentProcess()">
                    <span class="font-bold">{{ $t('pending_investment_process.resume_button') }}</span>
                </BaseButtonMuted>
            </div>
        </template>
    </Alert>
</template>

<style scoped></style>
